var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNintendolife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 0 122 97.8",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m75.117 47.165-10.3 47.5c-6.5-.7-14.1-.8-21-.2-.8-.6-1.8-1.4-1.6-1.9.1-.3 7.7-33 9.1-43.3.5-4.2.7-7.8-4-8-7-.1-11.6.4-11.6.4-5 18-8.3 35.3-11.2 53.1-6.6-.7-13.7-.7-20.6 0l-2-1.9c2.3-10.9 12.1-57.7 12.1-57.7 1.7-7.3 9.5-13.4 17-13.4l27 .1c12.9-.1 19.8 12.7 17.1 25.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M507.017 94.865c-9.1-.6-14.3-.6-22.8 0 0-.1-1.7-1.8-1.7-1.9 8.4-30.6 13.7-58 21.1-89.8 7.3.6 14.7.6 22.8 0 .1 0 1.6 2.1 1.7 2.1-8.2 31.8-14.5 58.8-21.1 89.6",
    transform: "translate(-410,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNintendolife);
export default __webpack_public_path__ + "static/media/nintendolife.96011794c2520654fd72e40ce4fcfc59.svg";
export { ForwardRef as ReactComponent };